import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth';

import TeenPreloadCardDataPage from './TeenPreloadCardData';

const TeenPreloadCardDataRoute: FuseRouteItemType = {
  path: '',
  element: <TeenPreloadCardDataPage />,
  auth: AUTH_ROLES.parent, // []
};

export default TeenPreloadCardDataRoute;
